
export default "/assets/book-open-mini.94a7509b.svg"